export default __webpack_public_path__ + "static/media/eghamat.7055dbb8.svg";